var _ = require('underscore');
var $ = require('jquery');
var demographicsExtService = require('./../../urls').demographicsExtService;
var TorsoFormView = require('backbone-torso/modules/FormView');
var eregStaffPatientLookupFormTemplate = require('./eregStaffPatientLookupFormTemplate.hbs');
var EregStaffPatientLookupResultsView = require('./EregStaffPatientLookupResultsView');
var demographicsCollection = require('./../../demographics/demographicsCollection');

/**
 * Default object of paging and sorting
 * TODO: PSS-11886 - implement paging and sorting
 */
var defaultPaging = {
      pageSize:25,
      pageNumber:0,
      orderingMap: {
        timestamp: true
      }
    };

/**
 * View for looking up patients and displaying them via a sub listview
 *
 * @class EregStaffPatientLookupPerspective
 * @constructor
 */
module.exports = TorsoFormView.extend({
  className: 'page-content page-content--ereg-staff-patient-lookup',
  tagName: 'main',
  moduleNamespace: 'eregStaffPatientLookup',
  template: eregStaffPatientLookupFormTemplate,
  events : {
    'submit': '_submit'
  },

  feedback: [{
    when: {
      'on': ['validate']
    },
    then: function() {
      return this._thenSetTextIfInvalid('searchCriteria', $.i18n.prop('eregPatientLookup.searchInput.error.noSearchCriteria'));
    },
    to: 'searchCriteriaError'
  }],

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, '_submit', '_fetchPatientIds', '_trackAndFetchDemographics', '_setLoadingDone');
    /**
     * @property privateDemographicsCollection {Torso.Collection} of patient data from search
     */
    this.privateDemographicsCollection = demographicsCollection.createPrivateCollection(this.cid);
    this._lookupResultsView = new EregStaffPatientLookupResultsView({collection: this.privateDemographicsCollection});

    /**
     * @property {String} requestState state of patient search requests for this view
     * Can be any of 'START', 'LOADING', 'DONE'
     */
    this.set('requestState', 'START');

    this.model.validation = {
      searchCriteria: {
        required: true
      }
    };

    this.updateAside();
    this.set('navView', 'eregStaff');

    this.listenTo(this.viewState, 'change:criteria', this._updateResultsView);
    this.listenTo(this.viewState, 'change:requestState', this.render);
    this.listenTo(this.privateDemographicsCollection, 'change', this.render);
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var requestState = this.get('requestState');
    var context = TorsoFormView.prototype.prepare.call(this);
    context[requestState] = true;
    context.numberOfResults = this.privateDemographicsCollection.length;
    context.showHelp = (requestState === 'START') || (requestState === 'DONE' && this.privateDemographicsCollection.length === 0);
    return context;
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    this.attachView('results', this._lookupResultsView);
  },

  /**
   * Set the criteria on the viewState
   *
   * @method _submit
   * @private
   */
  _submit: function(event) {
    event.preventDefault();

    this.set('criteria', {
      query: this.model.get('searchCriteria'),
      pagingAndSorting: defaultPaging
    });
  },

  /**
   * Updated the results view with fetched patient ids matching the criteria
   *
   * @method _updateResultsView
   * @private
   */
  _updateResultsView: function() {
    this.trigger('validate');
    var errors = this.model.validate();
    if (errors) {
      return;
    }

    this.updateAside();
    this.set('requestState', 'LOADING');
    this._fetchPatientIds()
      .then(this._trackAndFetchDemographics)
      .then(this._setLoadingDone, this._setLoadingDone);
  },

  /**
   * @method _trackAndFetchDemographics
   * @param response {Object} the response from the server when fetching ids.
   *   @param response.list {String[]} the ids from the server for the demographics to display.
   * @returns {jQuery.Promise} a jquery promise that will resolve/reject based on fetching the demographics by ids.
   * @private
   */
  _trackAndFetchDemographics: function(response) {
    return this.privateDemographicsCollection.trackAndFetch(response.list);
  },

  /**
   * update the request state to DONE.
   * @method _setLoadingDone
   * @private
   */
  _setLoadingDone: function() {
    this.set('requestState', 'DONE');
  },

  /**
   * Get patient ids matching criteria on the view state
   *
   * @method _fetchPatientDemographicsDtos
   * @private
   */
  _fetchPatientIds: function() {
    return $.ajax({
      url: demographicsExtService + '/search',
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(this.get('criteria'))
    });
  },

  /**
   * Update the content of the aside after submitting
   *
   * @method updateAside
   */
  updateAside: function() {
    var hasSubmitted = !!this.get('criteria');
    var contentMessageKey = hasSubmitted ? 'ereg.staffPatientLookup.results.aside' : 'ereg.staffPatientLookup.aside';
    this.set({
      asideHeaderMessageKey: 'ereg.appointments.aside.header',
      asideContentMessageKey: contentMessageKey
    });
  }
});
